import { render, staticRenderFns } from "./EditarSocio.vue?vue&type=template&id=f72fdf6c&scoped=true&"
import script from "./EditarSocio.vue?vue&type=script&lang=js&"
export * from "./EditarSocio.vue?vue&type=script&lang=js&"
import style0 from "./EditarSocio.vue?vue&type=style&index=0&id=f72fdf6c&prod&lang=css&"
import style1 from "./EditarSocio.vue?vue&type=style&index=1&id=f72fdf6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72fdf6c",
  null
  
)

export default component.exports